import { useState } from 'react';
import { Bell, MessageSquare } from 'lucide-react';
import { useNotifications } from '@/hooks/useNotifications';
import { NOTIFICATION_TEXT } from '@/context/notificationLabels';
import { cn } from '@/lib/utils';

// Sino de notificações do painel (barra de topo do desktop e do app).
export function SinoNotificacoes() {
  const { notifications, unreadCount, clear, goToConversation } = useNotifications();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        aria-label={`Notificações${unreadCount ? ` (${unreadCount})` : ''}`}
        onClick={() => setOpen((o) => !o)}
        className="relative flex size-9 shrink-0 items-center justify-center rounded-full text-text-secondary transition-colors hover:bg-muted hover:text-text-title"
      >
        <Bell size={20} />
        {unreadCount > 0 && (
          <span className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-error px-1 text-[10px] font-bold tabular-nums text-white ring-2 ring-bg-main">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-11 z-20 w-80 max-w-[calc(100vw-1.5rem)] overflow-hidden rounded-xl border border-border bg-card shadow-xl">
            <div className="flex items-center justify-between border-b border-border px-3 py-2">
              <span className="text-xs font-semibold text-text-title">Notificações</span>
              {notifications.length > 0 && (
                <button
                  type="button"
                  className="text-[11px] text-primary hover:underline"
                  onClick={clear}
                >
                  Limpar
                </button>
              )}
            </div>
            <div className="max-h-96 overflow-y-auto">
              {notifications.length === 0 ? (
                <p className="px-3 py-8 text-center text-xs text-text-tertiary">
                  Nenhuma notificação.
                </p>
              ) : (
                notifications.map((n) => (
                  <button
                    key={n.id}
                    type="button"
                    onClick={() => {
                      goToConversation(n.convId);
                      setOpen(false);
                    }}
                    className={cn(
                      'flex w-full items-start gap-2.5 border-b border-border px-3 py-2.5 text-left hover:bg-muted',
                      !n.read && 'bg-primary/5'
                    )}
                  >
                    <span className="mt-0.5 text-tertiary">
                      <MessageSquare size={15} />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-xs font-semibold text-text-title">
                        {n.title}
                      </span>
                      <span className="text-[11px] text-text-secondary">
                        Suporte · {NOTIFICATION_TEXT[n.kind].curto.toLowerCase()}
                      </span>
                    </span>
                    {!n.read && <span className="mt-1 size-2 shrink-0 rounded-full bg-primary" />}
                  </button>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
